export default "__VITE_ASSET__CTLIzZG7__"